import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Trophy, Users, PiggyBank, Award, Info } from 'lucide-react';
import { formatApiError } from '../../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const MedalIcon = ({ rank }) => (
  <div className={`w-8 h-8 rounded-full flex items-center justify-center font-black text-xs ${
    rank === 1 ? 'bg-gradient-to-br from-amber-300 to-amber-500 text-amber-950' :
    rank === 2 ? 'bg-gradient-to-br from-slate-300 to-slate-500 text-slate-900' :
                 'bg-gradient-to-br from-orange-400 to-orange-600 text-orange-950'
  }`}>{rank}º</div>
);

const PrizePoolCard = () => {
  const [pool, setPool] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    axios.get(`${API}/fantasy/prize-pool/current`).then(({ data }) => setPool(data)).catch((ex) => setErr(formatApiError(ex)));
  }, []);

  if (err) return <div className="text-xs text-red-300 bg-red-500/10 border border-red-500/30 rounded-lg p-2">{err}</div>;
  if (!pool) return null;

  return (
    <section className="bg-gradient-to-br from-emerald-950/70 to-slate-900/70 border border-emerald-400/30 rounded-2xl p-4 sm:p-5" data-testid="prize-pool-card">
      <div className="flex items-center justify-between gap-3 mb-4">
        <div className="flex items-center gap-2 min-w-0">
          <div className="w-9 h-9 rounded-lg bg-emerald-500/20 border border-emerald-400/30 flex items-center justify-center shrink-0">
            <PiggyBank className="w-4 h-4 text-emerald-300" />
          </div>
          <div className="min-w-0">
            <div className="text-white font-black text-sm sm:text-base leading-tight">Pote do Mês</div>
            <div className="text-emerald-200/80 text-[10px] sm:text-xs uppercase tracking-wider">{pool.month}</div>
          </div>
        </div>
        <div className="text-right">
          <div className="text-white font-black text-xl sm:text-2xl leading-tight">{pool.net_pool.toFixed(2)}€</div>
          <div className="text-emerald-200/70 text-[10px] sm:text-xs">líquido para prémios</div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2 mb-4">
        {[1, 2, 3].map((rank) => (
          <div key={rank} className="bg-slate-900/60 border border-white/5 rounded-xl p-2 sm:p-3 text-center" data-testid={`prize-rank-${rank}`}>
            <MedalIcon rank={rank} />
            <div className="text-white font-black text-base sm:text-lg mt-1.5 tabular-nums">{pool.distribution[rank].eur.toFixed(2)}€</div>
            <div className="text-slate-400 text-[10px]">{Math.round(pool.distribution[rank].pct * 100)}%</div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-3 gap-3 text-center text-[11px] sm:text-xs">
        <div>
          <div className="text-slate-400 flex items-center justify-center gap-1"><Users className="w-3 h-3" /> Treinadores</div>
          <div className="text-white font-bold text-sm tabular-nums">{pool.coaches}</div>
        </div>
        <div>
          <div className="text-slate-400 flex items-center justify-center gap-1"><Trophy className="w-3 h-3" /> Pote Bruto</div>
          <div className="text-white font-bold text-sm tabular-nums">{pool.gross_pool.toFixed(2)}€</div>
        </div>
        <div>
          <div className="text-slate-400 flex items-center justify-center gap-1"><Info className="w-3 h-3" /> Admin ({Math.round(pool.admin_fee_pct * 100)}%)</div>
          <div className="text-white font-bold text-sm tabular-nums">{pool.admin_fee.toFixed(2)}€</div>
        </div>
      </div>

      <div className="mt-3 pt-3 border-t border-white/5 flex items-start gap-2 text-[11px] text-emerald-200/70">
        <Award className="w-3.5 h-3.5 mt-0.5 shrink-0" />
        <span>
          Cada 1€M não gasto na tua escalação = <span className="text-emerald-300 font-bold">+{pool.budget_bonus_per_m} pts</span> na jornada.
          Fim do mês: admin encerra a época, os 3 melhores levam o prémio em dinheiro real via MB WAY.
        </span>
      </div>
    </section>
  );
};

export default PrizePoolCard;
